/**
 * Locale helpers for HearthHouse — defaults to Australia (en-AU, AUD, Australia/Sydney).
 * Values can be overridden by /api/config but defaults keep the app working offline.
 */

const DEFAULTS = {
  region: "Australia",
  timezone: "Australia/Sydney",
  currency: "AUD",
  currency_symbol: "$",
  locale: "en-AU",
};

let _cfg = { ...DEFAULTS };

export function setLocale(cfg) {
  _cfg = { ...DEFAULTS, ...(cfg || {}) };
}

export function getLocale() {
  return _cfg;
}

/** Format a number as currency. Handles null/undefined/NaN as em-dash. */
export function money(value, { withCents = true } = {}) {
  if (value == null || value === "" || Number.isNaN(Number(value))) return "—";
  const n = Number(value);
  try {
    return new Intl.NumberFormat(_cfg.locale, {
      style: "currency",
      currency: _cfg.currency,
      minimumFractionDigits: withCents ? 2 : 0,
      maximumFractionDigits: withCents ? 2 : 0,
    }).format(n);
  } catch {
    return `${_cfg.currency_symbol}${n.toFixed(withCents ? 2 : 0)}`;
  }
}

/** Format an ISO date (YYYY-MM-DD) or full datetime as "30 Jun 2026". Returns "—" for empty. */
export function fmtDate(iso, opts = { day: "2-digit", month: "short", year: "numeric" }) {
  if (!iso) return "—";
  try {
    const d = typeof iso === "string" && iso.length === 10
      ? new Date(iso + "T00:00:00")
      : new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return new Intl.DateTimeFormat(_cfg.locale, opts).format(d);
  } catch {
    return iso;
  }
}

/** "30 Jun" (no year) — useful for compact lists. */
export function fmtDateShort(iso) {
  return fmtDate(iso, { day: "2-digit", month: "short" });
}

/** Today as YYYY-MM-DD in the configured timezone (for date inputs). */
export function todayISO() {
  try {
    const fmt = new Intl.DateTimeFormat("en-CA", {
      timeZone: _cfg.timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    return fmt.format(new Date()); // en-CA produces YYYY-MM-DD
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}
